import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { fileResourceUrl } from '../../../utils/urlUtils';

const useMapImage = (monitor: string) => {
  const monitorMap = useSelector((state: any) => state.executor.monitorMaps);
  const token = useSelector((state: any) => state.authenticate.token);
  const isOffline = useSelector((state: any) => state.resources.offlineMode);
  const [url, setUrl] = useState('');
  const [corners, setCorners] = useState({
    leftUpperCorner: [],
    rightLowerCorner: [],
  });
  useEffect(() => {
    if (monitorMap && monitorMap[monitor]) {
      const mapObj =
        monitorMap[monitor]?.map?.mapByScale[monitorMap[monitor]?.zoomPosition];
      if (!mapObj) {
        return;
      }

      const { filename, value } = mapObj.mapImage;
      setCorners({
        leftUpperCorner: mapObj.leftUpperCorner,
        rightLowerCorner: mapObj.rightLowerCorner,
      });
      setUrl(fileResourceUrl(token, value, filename, isOffline));
      return;
    }
    setUrl('');
  }, [monitorMap, token]);

  return { url, corners };
};

export default useMapImage;
